import Quill from 'quill';

const Inline = Quill.import('blots/inline');

class Mention extends Inline {
  static blotName = 'mention';
  static tagName = 'a';
  static className = 'ql-mention';

  static create(value) {
    const node = super.create(value);

    node.setAttribute('href', Routes.user_path(value));
    node.setAttribute('target', '_blank');
    // Required by the back-end to send mention email
    node.setAttribute('data-mention', 'user');
    node.setAttribute('data-model-id', value);

    return node;
  }

  static formats(domNode) {
    return domNode.getAttribute('data-model-id');
  }
}

Inline.order = [
  'cursor',
  'inline',
  'underline',
  'strike',
  'italic',
  'bold',
  'script',
  'link',
  'mention',
  'code',
];

export default Mention;
